import { Box } from "grommet"
import { TwitchSettings } from "./TwitchSettings"
import { AuctionSettings } from "./AuctionSettings"

export const Settings = () => {

    return (
        <Box direction="column" gap="medium">
            <AuctionSettings />
            <TwitchSettings />
        </Box>
    )
}